import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required(),
  description: yup.string().label('Description').min(2, 'Description should be at least 2 symbols').required(),
  svilaClientInfoDecription: yup.string().label('Client Info').min(2, 'Client Info should be at least 2 symbols').required(),
  status: yup.number().label('Status').required(),
});

export default schema;
